import React from 'react'

import FormLabelM, { FormLabelProps } from '@mui/material/FormLabel'

type LocalProps = {
  children: any
}

const FormLabelWrapper: React.ComponentType<LocalProps & FormLabelProps> = ({
  children,
  required,
  ...rest
}) => {
  return (
    <FormLabelM {...rest} required={required}>
      {children}
    </FormLabelM>
  )
}

export default FormLabelWrapper
